import useSWR from 'swr';
import { CleanUser } from '../export-types/cleaned-types';
import { fetcher } from '../services/api';

export type UserProps = CleanUser & {
  moneyBill: { cny: number; usd: number };
  deliveryDebt: number | null;
  writeOffBill?: { cny: number; usd: number };
};

export function useUsers(
  role: string[],
  debouncedInternalId?: string,
  managerUUID?: string | null,
  sort?: string | null,
  take?: number,
  skip?: number,
  takeUnattached?: boolean,
) {
  const { data, isLoading, mutate } = useSWR<{
    total: number;
    items: Array<UserProps>;
  }>(
    () => ({
      url: '/user/v2',
      params: {
        takeUnattached,
        managerUUID,
        role,
        ...(debouncedInternalId
          ? {
              internalId: debouncedInternalId?.trim(),
              skip: 0,
            }
          : { skip }),
        take,
        sort,
        direction:
          sort === 'deliveryDebt' || sort === 'createdAt' ? 'desc' : 'asc',
      },
    }),
    fetcher,
  );
  return { data, isLoading, mutate };
}

/** Хук для получения комиссии для каждого пользователя */
export function useUsersCommission(
  ids: string[],
  getOnlyActive?: boolean,
  { enabled }: { enabled: boolean } = { enabled: true },
) {
  return useSWR<{
    list: {
      id: string;
      commission: number;
      promotionCommissions?: Array<{
        id: string;
        commission: number;
        endDate: Date;
      }>;
    }[];
  }>(
    () =>
      enabled &&
      ids.length > 0 && {
        url: '/client-expenses-purchase-markups/commission',
        params: {
          userIDs: ids,
          getOnlyActive,
        },
      },
    fetcher,
  );
}
